import * as React from 'react';
import * as Yup from 'yup';
import {inject, observer} from 'mobx-react';
import {Formik, FormikProps} from 'formik';
import {formValidatorFactory} from '../../utils';
import BaseForm, {FormValues} from './private/RegistrationFormBase';
import {Auth} from '../../models/authModel';

interface WithInjectedProps {
  auth: Auth;
}

@inject('auth')
@observer
export default class RegistrationForm extends React.Component<{}, {}> {
  public render() {
    const {sending} = this._withInjectedProps.auth.registration;
    return (
      <Formik
        initialValues={this._initialValues}
        validate={formValidatorFactory(this._getValidationSchema)}
        onSubmit={this._handleSubmit}
        render={(props: FormikProps<FormValues>) => <BaseForm {...props} loading={sending} />}
      />
    );
  }

  private get _initialValues() {
    return {email: '', password: '', passwordConfirm: '', firstName: '', lastName: ''};
  }

  private _getValidationSchema = (values: FormValues) => {
    return Yup.object().shape({
      firstName: Yup.string().required('Please enter your first name.'),
      lastName: Yup.string().required('Please enter your last name.'),
      email: Yup.string()
        .email('E-mail is not valid.')
        .required('Please enter your email.'),
      password: Yup.string()
        .min(6, 'Password must be longer than 6 characters.')
        .required('Please enter a password.'),
      passwordConfirm: Yup.string()
        .oneOf([values.password], 'Password confirmation must match.')
        .required('Please confirm your password.')
    });
  };

  private _handleSubmit = ({firstName, lastName, password, email}: FormValues) => {
    this._withInjectedProps.auth.sendRegistration({
      firstName,
      lastName,
      password,
      email,
      location: undefined
    });
  };

  private get _withInjectedProps() {
    return this.props as WithInjectedProps;
  }
}



// WEBPACK FOOTER //
// ./src/containers/RegistrationForm/RegistrationForm.tsx